/* RE Editorial page interactions — carousels, FAQ accordion, mobile nav, hero
   countdown, nav smooth-scroll, and the CTA video popup. Loaded once on the
   ro-editorial-custom-1 page. Defensive: every init no-ops if its markup is absent. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ---------- Carousels (Replo track: transform-based) ----------
     Behaviour differs per section (the Replo original wired them differently):
       - testimonials ("Hear more...")      -> auto-advance on a timer
       - reviews ("What Our Customers...")   -> auto-advance + keep the active card centred
       - reviews_carousel / ugc_gallery      -> click / tap the arrows to move
     Autoplay pauses on hover and while the section is off-screen. */
  function initCarousels() {
    document.querySelectorAll('[data-replo-carousel="true"]').forEach(function (car) {
      function isVis(e) { var n = e; while (n && n !== document.body) { if (getComputedStyle(n).display === 'none') return false; n = n.parentElement; } return true; }
      // Some carousels (reviews) ship a desktop AND a mobile track/dots set, one hidden per
      // breakpoint. Drive the VISIBLE variant so arrows/dots move what the user actually sees.
      var allTracks = [].slice.call(car.querySelectorAll('[data-replo-part="slide-track"]'));
      var track = allTracks.filter(isVis)[0] || allTracks[0];
      if (!track) return;
      var slides = track.querySelectorAll('[data-replo-part="slide"]');
      if (slides.length < 2) return;
      // Replo ships separate desktop + mobile arrow sets (one is hidden per breakpoint); bind ALL
      // so the visible ones work on both — querySelector alone grabbed only the hidden desktop pair.
      var prevs = car.querySelectorAll('[data-replo-part="nav-button"][data-direction="previous"]');
      var nexts = car.querySelectorAll('[data-replo-part="nav-button"][data-direction="next"]');
      var dotArr = [].slice.call(car.querySelectorAll('[aria-label^="Go to slide"], [data-replo-part="pagination"] [role="button"]')).filter(isVis);
      // The active dot is styled by an extra atomic class (Replo bakes it onto the exported
      // active dot); aria-current has no visual effect. Detect that class (present on exactly
      // one dot) so we can move it as the carousel advances.
      var dotActiveClass = '';
      (function () { var c = {}; dotArr.forEach(function (d) { (d.className || '').split(/\s+/).forEach(function (k) { if (k.indexOf('r-') === 0) c[k] = (c[k] || 0) + 1; }); }); dotActiveClass = Object.keys(c).filter(function (k) { return c[k] === 1; })[0] || ''; })();
      var box = track.closest('[data-replo-part="slides"]') || car.querySelector('[data-replo-part="slides"]');
      var n = slides.length, raf = null, fb = null, DUR = 400;

      var sec = car.closest('[id^="shopify-section"]'), secId = sec ? sec.id : '';
      // testimonials, reviews and ugc_gallery auto-advance (the Replo original does, and their
      // nav arrows are hidden 0x0); reviews also centres the active card.
      var isAutoplay = /__testimonials$|__reviews$|__ugc_gallery$/.test(secId);
      var isCenter = /__reviews$/.test(secId);

      // Reviews clones its unique slides (data-slide-source-index repeats 0..realCount-1), so the
      // active card can always be centred with real neighbours. Detect the unique count and loop
      // seamlessly: advance one cycle, then snap back one cycle with no transition (identical
      // content in an identical position) — the base does this; a plain wrap would rewind/rest.
      var srcIdx = [].slice.call(slides).map(function (s) { return parseInt(s.getAttribute('data-slide-source-index') || '0', 10); });
      var realCount = Math.max.apply(null, srcIdx.map(function (v) { return v + 1; })) || n;
      var loopStart = realCount; // has realCount clones before it (indices 0..realCount-1)
      var loopSeamless = isCenter && realCount >= 2 && (loopStart + realCount) < n;

      function step() {
        var r = slides[0].getBoundingClientRect();
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 0;
        return (r.width + gap) || 1;
      }
      // Centre mode: shift the track so the active card sits in the middle of the window.
      function centerOffset() {
        if (!isCenter) return 0;
        var cw = (box || car).clientWidth, sw = slides[0].getBoundingClientRect().width;
        return Math.max(0, (cw - sw) / 2);
      }
      // The CSS `transition: transform` on this GPU-composited track freezes updates,
      // so we drive the transform with transition:none!important and tween via setInterval.
      function setX(x) {
        track.style.setProperty('transition', 'none', 'important');
        track.style.setProperty('transform', 'translate3d(' + x + 'px,0px,0px)', 'important');
      }
      function maxScroll() { return Math.max(0, track.scrollWidth - (box || car).clientWidth); }
      function rawX(i) { return -i * step() + centerOffset(); }
      // Seamless loop centres every card (clones provide neighbours); otherwise clamp so the
      // window is always full of cards and never exposes empty space past the first/last card.
      function targetX() { var x = rawX(idx); return loopSeamless ? x : Math.max(-maxScroll(), Math.min(0, x)); }
      // Last index that still moves the track; past it the clamp pins to the end, so wrap here.
      function lastIdx() { var s = step(); return s ? Math.min(n - 1, Math.max(0, Math.ceil((maxScroll() + centerOffset()) / s))) : n - 1; }
      // initial index from the Replo export's starting transform
      var m0;
      try { m0 = new DOMMatrixReadOnly(getComputedStyle(track).transform); } catch (e) { m0 = { m41: 0 }; }
      var idx = Math.round(-(m0.m41 || 0) / step());
      if (!isFinite(idx) || idx < 0 || idx >= n) idx = 0;
      idx = loopSeamless ? loopStart : Math.max(0, Math.min(idx, lastIdx()));
      var curX = targetX();
      // One dot per UNIQUE slide (source-index): move the active class + aria-current to it.
      function updateDots() { if (!dotArr.length) return; var cur = srcIdx[((idx % n) + n) % n]; dotArr.forEach(function (d, i) { var on = i === cur; d.setAttribute('aria-current', on ? 'true' : 'false'); if (dotActiveClass) d.classList.toggle(dotActiveClass, on); }); }
      // Glide with requestAnimationFrame — display-synced, so it's smooth (a 16ms setInterval
      // tween stutters). rAF is throttled/absent in some embedded render contexts, so a timer
      // fallback lands on the target there (keeps automated checks + odd browsers working).
      function cancelTween() { if (raf) { cancelAnimationFrame(raf); raf = null; } if (fb) { clearTimeout(fb); fb = null; } }
      function animateTo(target) {
        cancelTween();
        var startX = curX, t0 = (window.performance && performance.now) ? performance.now() : Date.now();
        function frame(t) {
          var p = Math.min(1, (t - t0) / DUR);
          setX(startX + (target - startX) * (1 - Math.pow(1 - p, 3)));
          if (p < 1) raf = requestAnimationFrame(frame);
          else { raf = null; curX = target; }
        }
        raf = requestAnimationFrame(frame);
        fb = setTimeout(function () { fb = null; if (raf) { cancelAnimationFrame(raf); raf = null; setX(target); curX = target; } }, DUR + 80);
      }
      function go(i) {
        if (loopSeamless) {
          idx = i; animateTo(targetX());
          // Reached the trailing repeat: after the tween, snap back one cycle with no transition
          // (same content, same centred position) so the loop never rewinds or rests at an edge.
          if (idx >= loopStart + realCount) {
            var j = idx - realCount;
            setTimeout(function () { cancelTween(); idx = j; curX = rawX(idx); setX(curX); }, DUR + 90);
          }
        } else {
          var m = lastIdx() + 1; idx = ((i % m) + m) % m; animateTo(targetX());
        }
        updateDots();
      }

      var auto = null;
      function startAuto() { if (isAutoplay && !auto) auto = setInterval(function () { go(idx + 1); }, 4000); }
      function stopAuto() { if (auto) { clearInterval(auto); auto = null; } }

      prevs.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stopAuto(); go(idx - 1); startAuto(); }, true); });
      nexts.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stopAuto(); go(idx + 1); startAuto(); }, true); });
      // Click a dot -> jump to the next slide of that unique (source-index) testimonial.
      dotArr.forEach(function (d, i) {
        d.addEventListener('click', function (e) {
          e.preventDefault(); stopAuto();
          var t = idx; for (var k = 1; k <= n; k++) { if (srcIdx[(idx + k) % n] === i) { t = idx + k; break; } }
          go(t); startAuto();
        });
      });
      // ugc_gallery has no visible arrows, so tapping an image advances it (progress on click);
      // autoplay keeps running with a fresh interval after each tap.
      if (/__ugc_gallery$/.test(secId)) {
        [].slice.call(slides).forEach(function (s) {
          s.style.cursor = 'pointer';
          s.addEventListener('click', function (e) { e.preventDefault(); stopAuto(); go(idx + 1); startAuto(); });
        });
      }

      // Touch swipe (mobile): live-drag the visible track and advance when released past a
      // threshold. The slides container is touch-action:pan-y, so horizontal gestures are ours
      // while vertical page scrolling stays with the browser. preventDefault on a horizontal
      // drag also suppresses the synthesized click, so ugc_gallery won't double-advance.
      (function () {
        var surface = box || track; if (!surface) return;
        var sx = 0, sy = 0, dir = null, dragStart = 0, active = false;
        surface.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          active = true; dir = null; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
          dragStart = curX; stopAuto(); cancelTween();
        }, { passive: true });
        surface.addEventListener('touchmove', function (e) {
          if (!active || e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
          if (dir === null) { if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return; dir = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v'; }
          if (dir === 'h') { e.preventDefault(); curX = dragStart + dx; setX(curX); }
        }, { passive: false });
        function end(e) {
          if (!active) return; active = false;
          if (dir !== 'h') { startAuto(); return; }
          var ex = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : sx;
          var dx = ex - sx, thresh = Math.max(40, (surface.clientWidth || 300) * 0.12);
          if (Math.abs(dx) > thresh) go(idx + (dx < 0 ? 1 : -1)); else animateTo(targetX());
          startAuto();
        }
        surface.addEventListener('touchend', end);
        surface.addEventListener('touchcancel', end);
      })();

      window.addEventListener('resize', function () { curX = targetX(); setX(curX); });

      if (isAutoplay) {
        startAuto(); // begin immediately; the observer below pauses it while off-screen
        var hoverEl = box || car, watchEl = sec || car;
        hoverEl.addEventListener('mouseenter', stopAuto);
        hoverEl.addEventListener('mouseleave', startAuto);
        // The carousel element itself can be 1px tall (its slides overflow it), which makes it an
        // unreliable IntersectionObserver target — observe the section (real height) instead.
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) startAuto(); else stopAuto(); });
          }, { threshold: 0 }).observe(watchEl);
        }
      }

      setX(curX); updateDots();
    });
  }

  /* ---------- FAQ / collapsible accordions ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-replo-collapsible="true"]').forEach(function (item) {
      var header = item.firstElementChild;
      var content = item.children[1] || item.querySelector('.replo-animated, [id^="replo-"]');
      if (!header) return;
      function setOpen(open) {
        item.setAttribute('data-state', open ? 'open' : 'closed');
        var exp = item.querySelector('[aria-expanded]');
        if (exp) exp.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (content) {
          if (open) { content.hidden = false; content.removeAttribute('hidden'); content.style.display = ''; }
          else { content.style.display = 'none'; }
        }
      }
      setOpen(item.getAttribute('data-state') === 'open');
      header.style.cursor = 'pointer';
      header.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(item.getAttribute('data-state') !== 'open');
      });
    });
  }

  /* ---------- Mobile nav (hamburger toggles the menu panel) ---------- */
  function initMobileNav() {
    var mob = document.getElementById('nav-sticky-mobile');
    if (!mob) return;
    var burger = mob.querySelector('.r-7d24qr');
    var panel = mob.querySelector('.r-ox21oo');
    if (!burger || !panel) return;
    // The desktop header carries its own hamburger (r-v15afm) that Replo only ever displayed at
    // mobile - where this section replaces that header, so it never actually rendered anywhere.
    // It is shown at 641-1024px (re-editorial-base.css) so the tablet header can reach this same
    // panel; wire it to the same toggle.
    var burgers = [burger];
    var tabletBurger = document.querySelector('#nav-sticky .r-v15afm [role="button"]') ||
                       document.querySelector('#nav-sticky .r-v15afm');
    if (tabletBurger) burgers.push(tabletBurger);
    panel.style.display = 'none';
    var open = false;
    // Open must set an explicit display: the panel's own CSS is display:none, so '' would just
    // fall back to hidden. flex renders the menu links as the intended vertical list.
    function set(o) { open = o; panel.style.setProperty('display', o ? 'flex' : 'none', 'important'); }
    burgers.forEach(function (b) {
      b.style.cursor = 'pointer';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); set(!open); });
    });
    // close when a menu item is tapped
    panel.addEventListener('click', function () { set(false); });
  }

  /* ---------- Long-translation guards (label auto-fit + bullet stacking) ---------- */
  function lineCountOf(el) {
    var range = document.createRange(); range.selectNodeContents(el);
    var rects = range.getClientRects(), tops = {}, n = 0;
    for (var i = 0; i < rects.length; i++) { var t = Math.round(rects[i].top); if (!tops[t]) { tops[t] = 1; n++; } }
    return n;
  }
  // Any descendant sticking out past the button's own box - the label spilling sideways is the
  // usual case, since the buttons are overflow:hidden and clip it.
  function spillOf(a) {
    var ar = a.getBoundingClientRect(), kids = a.querySelectorAll("*"), worst = -999;
    for (var i = 0; i < kids.length; i++) {
      var r = kids[i].getBoundingClientRect();
      if (!r.width && !r.height) continue;
      worst = Math.max(worst, r.right - ar.right, ar.left - r.left, r.bottom - ar.bottom, ar.top - r.top);
    }
    return worst;
  }
  // German labels ("Hol dir das 3-Sekunden-Zelt - 62 % Rabatt") are far wider than the English.
  // In the wide buttons the text spills sideways and is clipped; in the narrow ones it wraps to a
  // second line. Shrink the label until it neither spills nor wraps, rather than resizing buttons.
  function fitCtaText() {
    document.querySelectorAll("a.text.alchemy-rte").forEach(function (a) {
      var p = a.querySelector("p");
      if (!p || !a.getBoundingClientRect().width) return;
      p.style.fontSize = "";                    // always re-measure from the stylesheet size
      var size = parseFloat(getComputedStyle(p).fontSize) || 16, guard = 0;
      // -10 rather than 0: stopping the moment it technically fits leaves the label touching
      // the button edges. Keep at least 10px of clearance on every side.
      // Client rule: never below 16px - anything smaller is raised to 16 and a label that still
      // does not fit wraps to a second line. The sticky header is the exception: at 16px its
      // label needs 394px against a 390px button, and wrapping would push the header 48 -> 68px,
      // so there it shrinks to hold one line instead.
      var inNav = !!a.closest("#nav-sticky");
      var floor = inNav ? 10 : 16;
      if (!inNav && size < 16) { size = 16; p.style.fontSize = "16px"; }
      while ((spillOf(a) > -10 || lineCountOf(p) > 1) && size > floor && guard++ < 40) {
        size -= 0.5; p.style.fontSize = size + "px";
      }
    });
  }

  // Nav links sit between the logo and the CTA with no gap of their own. Longer labels (French:
  // "Tente instantanee" ... "Pourquoi nous choisir") fill the space exactly and end up touching
  // both. Shrink the link text until there is 12px of clearance on each side, floor 12px.
  function fitNavLinks() {
    var nav = document.querySelector("#nav-sticky .r-rv07od");
    var logo = document.querySelector("#nav-sticky .r-huujv7");
    var cta = document.querySelector("#nav-sticky a.text.alchemy-rte");
    if (!nav || !logo || !cta || !nav.getBoundingClientRect().width) return;
    var ps = nav.querySelectorAll("p");
    if (!ps.length) return;
    for (var i = 0; i < ps.length; i++) ps[i].style.fontSize = "";
    function clearance() {
      var kids = nav.children, left = Infinity, right = -Infinity;
      for (var j = 0; j < kids.length; j++) {
        var b = kids[j].getBoundingClientRect();
        if (!b.width) continue;
        left = Math.min(left, b.left); right = Math.max(right, b.right);
      }
      if (left === Infinity) return 999;
      return Math.min(left - logo.getBoundingClientRect().right, cta.getBoundingClientRect().left - right);
    }
    var size = parseFloat(getComputedStyle(ps[0]).fontSize) || 16, guard = 0;
    while (clearance() < 12 && size > 12 && guard++ < 20) {
      size -= 0.5;
      for (var k = 0; k < ps.length; k++) ps[k].style.fontSize = size + "px";
    }
  }

  // Video-sec bullets are a nowrap row that long copy overflows. Stack all three when they do not
  // fit; the stylesheet already stacks them below 1350px, this covers wider viewports and any
  // language, and reverts by itself when the copy does fit.
  function stackBulletsIfOverflowing() {
    var list = document.querySelector(".r-btmsgy");
    if (!list) return;
    list.classList.remove("re-stack");
    if (list.scrollWidth > list.clientWidth + 1) list.classList.add("re-stack");
  }
  // A third-party experiment script (scripts.conversion.io / __AcceleratedAgencyExperiments__)
  // wraps the CTA promo line in a bare <a href="...3-secs-tent">, which is not in our markup and
  // renders the text underlined. Unwrap it: only an anchor with no class holding exactly that div.
  function unwrapInjectedPromoAnchor() {
    var promo = document.querySelector(".r-pquous");
    if (!promo) return;
    var a = promo.closest("a");
    if (!a || a.getAttribute("class") || a.children.length !== 1) return;
    a.parentNode.insertBefore(promo, a);
    a.remove();
  }
  function initLongTextGuards() {
    // nav first: resizing the links changes how much room the CTA label has
    function run() { try { unwrapInjectedPromoAnchor(); } catch (e) {} try { fitNavLinks(); } catch (e) {} try { fitCtaText(); } catch (e) {} try { stackBulletsIfOverflowing(); } catch (e) {} }
    run();
    // Re-run late: webfonts land after first paint, and the third-party experiment script rewrites
    // the DOM after we fit - measured on the live DE page, the labels spilled again by 2-5px until
    // a second pass ran.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    window.addEventListener("load", run);
    setTimeout(run, 1500); setTimeout(run, 4000);
    var t; window.addEventListener("resize", function () { clearTimeout(t); t = setTimeout(run, 150); });
  }

  /* ---------- Loox rating label (live count + translatable word) ---------- */
  // The markup ships a static fallback ("4,369 Reviews"). Loox upgrades the widget with the live
  // count but writes its own English word, so mirror what the PDP does: keep the number Loox
  // renders and swap the word for the section setting, which Translate & Adapt can localise.
  function initLooxLabel() {
    var rating = document.querySelector(".loox-rating[data-re-review-word]");
    if (!rating) return;
    var word = (rating.getAttribute("data-re-review-word") || "").trim();
    if (!word) return;
    function sync() {
      var label = rating.querySelector(".loox-rating-label");
      if (!label) return;
      var m = (label.textContent || "").match(/\d[\d.,   ]*\d|\d/);  // the count, however Loox formats it
      if (!m) return;
      var text = " " + m[0].trim() + " " + word;
      if (label.textContent !== text) label.textContent = text;
    }
    // Loox rewrites the label asynchronously; re-apply after it lands.
    sync(); setTimeout(sync, 1500); setTimeout(sync, 4000);
  }

  /* ---------- Nav smooth-scroll (label -> section id) ---------- */
  var NAV_MAP = {
    'instant setup': 'video_sec', 'how to set-up': 'HTU', 'how to set up': 'HTU',
    'benefits': 'BENIFITS', 'reviews': 'REVIEWS', 'faq': 'faqs', 'why us': 'WHY'
  };
  function initNavScroll() {
    ['nav-sticky', 'nav-sticky-mobile'].forEach(function (navId) {
      var nav = document.getElementById(navId);
      if (!nav) return;
      nav.querySelectorAll('p').forEach(function (p) {
        var btn = p.closest('[role="button"]') || p.parentElement;
        if (!btn || btn.__reWired) return;
        // Each menu item now carries its own destination (nav_link_N_url / nav_item_N_url).
        // Fall back to the label lookup only when that setting was cleared - the labels are
        // editable, so a renamed item used to silently stop scrolling anywhere.
        var dest = (btn.getAttribute('data-lp-nav') || '').trim();
        if (!dest) {
          var mapped = NAV_MAP[(p.textContent || '').trim().toLowerCase()];
          if (!mapped) return;
          dest = '#' + mapped;
        }
        btn.__reWired = 1; btn.style.cursor = 'pointer';
        btn.addEventListener('click', function (e) {
          if (dest.charAt(0) === '#') {
            var el = document.getElementById(dest.slice(1));
            if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
            return;
          }
          e.preventDefault();
          window.location.href = dest;
        });
      });
    });
  }

  /* ---------- Hero countdown (HRS / MIN / SEC) ---------- */
  function initCountdown() {
    var hero = document.getElementById('hero');
    if (!hero) return;
    var digits = [].slice.call(hero.querySelectorAll('p, span')).filter(function (e) {
      return e.children.length === 0 && /^\d{2}$/.test((e.textContent || '').trim());
    });
    if (digits.length < 3) return;
    var h = parseInt(digits[0].textContent, 10), m = parseInt(digits[1].textContent, 10), s = parseInt(digits[2].textContent, 10);
    var total = h * 3600 + m * 60 + s;
    var initial = total;
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function tick() {
      if (total <= 0) total = initial;
      total--;
      var hh = Math.floor(total / 3600), mm = Math.floor((total % 3600) / 60), ss = total % 60;
      digits[0].textContent = pad(hh); digits[1].textContent = pad(mm); digits[2].textContent = pad(ss);
    }
    setInterval(tick, 1000);
  }

  /* ---------- Video popup (any [data-re-video-src]) ---------- */
  function initVideoPopup() {
    var triggers = document.querySelectorAll('[data-re-video-src]');
    if (!triggers.length) return;
    var overlay;
    function open(src) {
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 're-video-overlay';
        overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.82);display:flex;align-items:center;justify-content:center;padding:20px;';
        overlay.innerHTML = '<div style="position:relative;width:min(900px,92vw);"><button type="button" aria-label="Close" class="re-video-close" style="position:absolute;top:-40px;right:0;font-size:30px;line-height:1;color:#fff;background:none;border:0;cursor:pointer;">&times;</button><video class="re-video-el" controls playsinline style="width:100%;height:auto;border-radius:10px;background:#000;"></video></div>';
        document.body.appendChild(overlay);
        overlay.addEventListener('click', function (e) { if (e.target === overlay || e.target.className === 're-video-close') close(); });
      }
      var v = overlay.querySelector('.re-video-el');
      v.src = src; overlay.style.display = 'flex'; v.play().catch(function () {});
    }
    function close() { if (!overlay) return; var v = overlay.querySelector('.re-video-el'); v.pause(); v.removeAttribute('src'); v.load(); overlay.style.display = 'none'; }
    triggers.forEach(function (t) {
      t.style.cursor = 'pointer';
      t.addEventListener('click', function (e) {
        var src = t.getAttribute('data-re-video-src');
        if (src) { e.preventDefault(); e.stopPropagation(); open(src); }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Lazy background videos ---------- */
  /* The page ships 14 autoplaying background mp4s (~29MB) and every one of them was downloaded on
     load. The markup now renders them with no src and preload="none"; this attaches the source and
     starts playback once a video comes within 300px of the viewport, and pauses it again when it
     leaves. Same approach as the PDP (snippets/lp-interactions.liquid). Videos already on screen
     at load still start immediately - the observer fires for them on its first pass. */
  function initLazyVideos() {
    var vids = [].slice.call(document.querySelectorAll('video.re-lazy-video[data-re-lazy-video]'));
    if (!vids.length) return;
    function load(v) {
      if (v.dataset.reLoaded) return;
      var src = v.getAttribute('data-re-lazy-video');
      if (!src) return;                       // blank section setting - nothing to load
      v.dataset.reLoaded = '1';
      v.src = src;
      try { v.load(); } catch (e) {}
    }
    function play(v) {
      var p = v.play();
      // Autoplay can be refused (iOS Low Power Mode). preload="none" means nothing has been
      // fetched yet, so a refusal would leave an empty box - pull enough to paint frame one.
      if (p && p.catch) p.catch(function () { try { v.preload = 'metadata'; v.load(); } catch (e) {} });
    }
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { load(v); play(v); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          // Smooth-scrolling to an anchor flies through every section in between, which would
          // trip all 13 videos at once. Commit only if it is still on screen 150ms later.
          if (v.reLazyTimer) return;
          v.reLazyTimer = setTimeout(function () { v.reLazyTimer = 0; load(v); play(v); }, 150);
        } else {
          if (v.reLazyTimer) { clearTimeout(v.reLazyTimer); v.reLazyTimer = 0; }
          if (v.dataset.reLoaded) { try { v.pause(); } catch (e) {} }
        }
      });
    }, { rootMargin: '300px 0px' });
    vids.forEach(function (v) {
      if (v.dataset.reObserved) return;       // idempotent: re-runs only pick up new elements
      v.dataset.reObserved = '1';
      io.observe(v);
    });
  }

  /* The tablet burger panel is pinned under the header with a hard-coded top:94px
     (assets/re-editorial-base.css). Once the French/German nav CTA wraps to two lines the header
     is taller than that, so measure it instead. Tablet only - at other widths the CSS owns it. */
  function syncNavPanelTop() {
    var panel = document.querySelector('.r-15ecumr');
    var nav = document.querySelector('#nav-sticky');
    if (!panel || !nav) return;
    if (window.matchMedia('(min-width:641px) and (max-width:1024px)').matches) {
      panel.style.setProperty('top', Math.round(nav.getBoundingClientRect().height) + 'px', 'important');
    } else {
      panel.style.removeProperty('top');
    }
  }

  ready(function () {
    try { initLazyVideos(); } catch (e) {}
    try { syncNavPanelTop(); } catch (e) {}
    try { initCarousels(); } catch (e) {}
    try { initAccordions(); } catch (e) {}
    try { initMobileNav(); } catch (e) {}
    try { initNavScroll(); } catch (e) {}
    try { initLooxLabel(); } catch (e) {}
    try { initLongTextGuards(); } catch (e) {}
    try { initCountdown(); } catch (e) {}
    try { initVideoPopup(); } catch (e) {}
  });

  // The theme editor re-renders a section's HTML after ready() has run, so its videos would never
  // be observed and would sit black for the merchant. initLazyVideos() is idempotent.
  document.addEventListener('shopify:section:load', function () { try { initLazyVideos(); } catch (e) {} });
  (function(){ var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(function(){ try { syncNavPanelTop(); } catch (e) {} }, 150); }, { passive: true }); })();
  window.addEventListener('load', function(){ try { syncNavPanelTop(); } catch (e) {} });
})();
/* build: editorial lazy background videos + carousels autoplay (testimonials, reviews, ugc_gallery) */
